import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default createStore({
  plugins: [vuexLocal.plugin],
  state: {
    user: null,
    checkInStatus: false,
    patients: [],
    appointments: [],
    medications: [],
    tasks: [],
    offlineData: []
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      if (typeof user?.checkInStatus === 'boolean') {
        state.checkInStatus = user.checkInStatus
      }
    },
    SET_CHECK_IN_STATUS(state, status) {
      state.checkInStatus = status
      if (state.user) {
        state.user = {
          ...state.user,
          checkInStatus: status
        }
      }
    },
    SET_PATIENTS(state, patients) {
      state.patients = patients
    },
    ADD_PATIENT(state, patient) {
      state.patients.push(patient)
    },
    UPDATE_PATIENT(state, updatedPatient) {
      const index = state.patients.findIndex(p => p.id === updatedPatient.id)
      if (index !== -1) {
        state.patients[index] = updatedPatient
      }
    },
    ADD_APPOINTMENT(state, appointment) {
      state.appointments.push(appointment)
    },
    ADD_OFFLINE_DATA(state, data) {
      state.offlineData.push(data)
    },
    CLEAR_OFFLINE_DATA(state) {
      state.offlineData = []
    }
  },
  actions: {
    async syncOfflineData({ state, commit }) {
      if (navigator.onLine && state.offlineData.length > 0) {
        // Sync offline data to server
        for (const data of state.offlineData) {
          // TODO: Send to server when API is ready
          console.log('Syncing data:', data)
        }
        commit('CLEAR_OFFLINE_DATA')
      }
    }
  },
  getters: {
    todayAppointments: state => {
      const today = new Date().toISOString().split('T')[0]
      return state.appointments.filter(apt => 
        apt.date === today && apt.status !== 'completed'
      )
    },
    pendingTasks: state => {
      return state.tasks.filter(task => !task.completed)
    }
  }
})